<div class="layout-footer">
  <img
    id="footer-logo"
    [src]="'assets/images/logos/logo-apes-' + logo + '.svg'"
    alt="kanzi-layout"
  />
  <div class="flex gap-2">
    <span class="footer-app-name" id="versionStep"
      >Kanzi v{{ versionName() }}</span
    >
    <span class="footer-copyright">&#169; Technoapes - {{ year }}.</span>
  </div>
</div>
